import _find from 'lodash/find';
import _get from 'lodash/get';
import { GRADEBOOK_SETTINGS } from '@macmillan-learning/gradebook-shared';

import { getGradebook, getGradebookInstructor } from './getGradebook';
import * as actions from '../redux/constants';
import * as lmsService from '../core/lms';
import { updateAssignmentAverages } from './averages';

export { getStudentGradeObj } from './student-grade-obj';

// TODO some actions can be replaced by calling updateGradebook
export const updateGradebook = (gradebook) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_GRADEBOOK,
    gradebook,
  });
};

export const updateAlert = (alert) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_GRADEBOOK_ALERT,
    alert,
  });
};

export const updateInstructor = (instructor) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_GRADEBOOK_INSTRUCTOR,
    instructor,
  });
};

export const updateStudent = (currentStudent) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_GRADEBOOK_STUDENT,
    currentStudent,
  });
};

export const updateSearchType = (searchType) => (dispatch) => {
  dispatch({
    type: actions.UPDATE_SEARCH_TYPE,
    searchType,
  });
};

export const updateSearchTypeMenu =
  ({ open, anchorEl }) =>
  (dispatch) => {
    dispatch({
      type: actions.UPDATE_SEARCH_TYPE_MENU,
      anchorEl,
      open,
    });
  };

export const setVisibleFilterSection = (section) => (dispatch) => {
  dispatch({ type: actions.SET_VISIBLE_FILTER_SECTION, section });
};

const saveGradebookOverride = async (promises, info, options, dispatch) => {
  if (promises.length === 0) {
    dispatch({
      type: actions.APP_LOADING,
      payload: false,
    });
    return null;
  }

  const data = await Promise.all(promises);

  const refreshOptions = { ...options, forceGradebookRefresh: true };
  if (info.isGradebookV2Active) {
    dispatch(getGradebookInstructor(info.courseId, refreshOptions));
  } else {
    dispatch(getGradebook(info.courseId, refreshOptions));
  }
  dispatch(updateAssignmentAverages([info.assignmentId]));

  dispatch({
    type: actions.APP_LOADING,
    payload: false,
  });

  if (data.length === 1) {
    return data[0];
  } else if (data.length === 2) {
    return {
      success: `${data[0].success}  ${data[1].success}`,
    };
  }
  // TODO: linting change here
  throw new Error('Sorry but an unknown error has occurred');
};

export const overrideGrade = (info, options) => async (dispatch) => {
  try {
    dispatch({
      type: actions.APP_LOADING,
      payload: true,
    });

    const promises = [];
    const newGrade = parseFloat(info.grade);

    // Only save if the grade was actually changed
    if (!isNaN(newGrade) && info.gradeHasChanges) {
      promises.push(lmsService.overrideGrade(info));
    }

    const originalComment = info.gradeComment || '';
    const newComment = info.comment || '';
    if (originalComment !== newComment) {
      promises.push(lmsService.putGradebookComment(info));
    }

    return saveGradebookOverride(
      promises,
      { ...info, userId: info.userId || info.studentId },
      options,
      dispatch,
    );
  } catch (error) {
    dispatch({
      type: actions.APP_LOADING,
      payload: false,
    });
    throw error;
  }
};

export const updateGradebookSettingsAndCategories =
  (courseId, settings, categories) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.GRADEBOOK_SETTINGS_UPDATING,
        payload: true,
      });
      dispatch({
        type: actions.APP_LOADING,
        payload: true,
      });

      const isGradingTypeStandard =
        _get(_find(settings, { key: 'gradingType' }), 'value') ===
        GRADEBOOK_SETTINGS.gradingTypeStandard;
      /* Make the updates */
      const updatedCategories = await lmsService.updateGradebookCategories(
        courseId,
        categories,
        isGradingTypeStandard,
      );
      const updateSettings = await lmsService.updateGradebookSettings(
        courseId,
        settings,
      );
      dispatch({
        type: actions.UPDATE_COURSE_GRADEBOOK_CATEGORIES,
        payload: updatedCategories.updatedCategories,
      });

      dispatch({
        type: actions.DELETE_COURSE_GRADEBOOK_CATEGORIES,
        payload: updatedCategories.deletedCategories,
      });

      dispatch({
        type: actions.GET_GRADEBOOK_SETTINGS_SUCCESS,
        payload: updateSettings,
      });

      const isGradebookV2Active = getState().gradebook.isGradebookV2Active;
      if (isGradebookV2Active) {
        dispatch(getGradebookInstructor(courseId));
      } else {
        dispatch(getGradebook(courseId));
      }

      dispatch({
        type: actions.GRADEBOOK_SETTINGS_UPDATING,
        payload: false,
      });
      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });
    } catch (e) {
      dispatch({
        type: actions.APP_ERROR,
        payload: e,
      });
      dispatch({
        type: actions.GRADEBOOK_SETTINGS_UPDATING,
        payload: false,
      });
      dispatch({
        type: actions.APP_LOADING,
        payload: false,
      });
      throw e;
    }
  };
